import type { RovoChatSourceMode } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

/**
 * Strict source mode is only valid for Space-scoped sends while the frontend
 * rollout gate is enabled. Returning undefined preserves the pre-feature
 * request shape for every other caller.
 */
export function getSpaceScopedSourceMode({
	isEnabled,
	sourceMode,
	spaceId,
}: {
	isEnabled: boolean;
	sourceMode?: RovoChatSourceMode;
	spaceId?: string;
}): RovoChatSourceMode | undefined {
	return isEnabled && spaceId ? sourceMode : undefined;
}
